import $http from '@vue-util/http';

function isExcludeUrl() {
  const currentUrl = window?.location?.pathname;
  if (currentUrl && (currentUrl.includes('createaccount') || currentUrl.includes('signin') || currentUrl.includes('forgot-password'))) {
    return true;
  }
  return false;
}

export default function () {
  $http.interceptors.request.use(
    async (request) => {
      if (!isExcludeUrl()) {
        const { PersistentLoginUtil } = await import('@vue-util/persistentLogin');
        request.headers = {
          ...request.headers,
          ...PersistentLoginUtil.getDeviceFingerPrintHeaders(),
        };
      }
      return request;
    },
    (error) => Promise.reject(error),
  );
}
